import { render, staticRenderFns } from "./custom.vue?vue&type=template&id=0db745b4&"
import script from "./custom.vue?vue&type=script&lang=ts&"
export * from "./custom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports